import size from 'lodash/size'
import {
  filterExistOptions,
  getActiveOption,
  isPlayersCardsCountEqual,
  isReadyToCalculateOdds,
  tableFlopValidation,
  whichHandWinsValidation,
} from './common'
import {TYPE_PLAYER} from '../constants/types'
import {
  ERROR_FLOP_POC_INFO,
  ERROR_NOCOMMUNITY_EQUALITY_POC_INFO,
  ERROR_NOCOMMUNITY_POC_INFO,
  ERROR_POC_INFO,
  MENU_CURRENT_FIELD_PLAYER,
  MENU_CURRENT_FIELD_TABLE, MENU_CURRENT_FIELD_TABLE_WHW,
  MENU_ERROR_HINT_INFO,
} from '../constants/translations'
import {TYPE_POC} from '../constants/types'
import {fromJS} from 'immutable/dist/immutable'
import {menuCards} from '../constants/initialData'

export const getPreparedMenuProps = (state) => {
  const menu = state.menu.toJS();
  const settings = state.settings.toJS();
  const board = state.board.toJS();
  const hintsState = state.hints.toJS();
  const players = board.players;
  const table = board.table;
  const activeField = board.activeField;
  const activeFieldType = activeField.type;
  const activeFieldId = activeField.id;
  const activeFieldCardId = activeField && activeField.card.id;
  const activeFieldCardType = activeField && activeField.card.type;
  const isPOC = settings.id === TYPE_POC;
  const everythingChosen = whichHandWinsValidation(players, table);
  const settingsRules = settings.rules;
  const activeRules = getActiveOption(settingsRules).rules;
  const noCommunityCards = activeRules.noCommunityCards;
  const settingsPlayers = settings.players;

  const getErrorInfo = () => {
    if (isPOC) {
      if (noCommunityCards) {
        if (!isReadyToCalculateOdds(players, table, activeRules)) {
          return ERROR_NOCOMMUNITY_POC_INFO
        }
        if (!isPlayersCardsCountEqual(players)) {
          return ERROR_NOCOMMUNITY_EQUALITY_POC_INFO
        }
      }
      return tableFlopValidation(table.flop)
        ? ERROR_POC_INFO
        : ERROR_FLOP_POC_INFO
    }
    return MENU_ERROR_HINT_INFO;
  };

  const currentFieldInfo = () => {
    if (activeFieldType === TYPE_PLAYER || !size(table)) {
      if (activeFieldType !== TYPE_PLAYER && !size(table)) {
        return `${MENU_CURRENT_FIELD_PLAYER} ${players.length}: `
      }
      return `${MENU_CURRENT_FIELD_PLAYER} ${activeField.id + 1}: `
    }
    return isPOC ? MENU_CURRENT_FIELD_TABLE : MENU_CURRENT_FIELD_TABLE_WHW;
  };

  const getCardsLeftToPick = () => {
    let cardToPick = 0;
    if (activeFieldType === TYPE_PLAYER) {
      const allPlayerCards = players[activeField.id].hand;
      const filledCards = filterExistOptions(allPlayerCards);
      cardToPick = allPlayerCards.length - filledCards.length;
    } else {
      for (const field in table) {
        const tableField = table[field];
        const tableFieldLength = tableField.length;
        if (tableFieldLength) {
          cardToPick += tableFieldLength - filterExistOptions(tableField).length;
        }
        if (!tableField) {
          cardToPick++
        }
      }
    }
    return cardToPick
  };

  return {
    hints: hintsState.hints,
    cardsLeftToPick: getCardsLeftToPick(),
    currentFieldInfo: currentFieldInfo(),
    errorInfo: getErrorInfo(),
    menu,
    settingsPlayers,
    settingsRules,
    players,
    table,
    isPOC,
    activeFieldType,
    activeFieldId,
    activeFieldCardId,
    activeFieldCardType,
    everythingChosen,
    noCommunityCards,
  };
};

export const menuInitialState = fromJS(menuCards);